import { Avatar, Empty } from 'antd';

import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import StreamWebService from '../../classes/StreamWebService';
import GlobalStateContext from '../../context';
import env from '../../environments';
import CustomSearch from '../../pages/protected/streams/components/CustomSearch';
import { buildCategoryHashtags, url } from '../../utils';
import Greetings from '../Greetings';
import LoadingCards from '../LoadingCards';
import LocalMoneyValue from '../LocalMoneyValue';

export function LiveEventItem({ item }) {
    const { streamingServer } = env.app.api;
    const { live } = streamingServer.apps
    const [state,] = useContext(GlobalStateContext);

    const [color, setColor] = useState(["green", "danger", "warning"][item.status]);
    const isPremium = item.ppv_value > 0.00;
    const { user,stream_destinations } = state;
    const _itemLink = (!!user || isPremium) ? url(`stream/${item.id}/watch`, true) : url(`${item.id}/watch`, false)
    const snapshot =  item.image;


    const {destinations} = item;



    const buildCategory = () => {
        const cat = item.category;
        return typeof cat === String ?
            <span className="badge badge-info">{cat || "N/A"}</span> :
            item.category.map(ct => <span key={ct} className="badge badge-info m-r-5">{ct}</span>)
    }
    const buildDestinations = () => {
        const already=[]
        return destinations.map(dest => {
           if( already.indexOf(dest.type) ==-1){
               already.push(dest.type)
               const ddt = stream_destinations.find(_=>_.id == dest.type ) ;
               return ddt ?  <Avatar  size="small" className="m-1" src={ddt.logo}/> : <></>
            }
        })
    }
    return (
        <Link to={_itemLink}>
            <div className="event bg-light  br-10">

                <div className="image " style={{ backgroundImage: `url(${snapshot})`, borderRadius: "5px 5px 5px 5px " }}>
                    <div className="filter br-5"></div>
                    {/* 
                    <div className="play-button-container" hidden={item.status !== '1'}>
                        <span href={_itemLink} className="btn btn-default play-button-link" >
                            <Icon type="play-circle" style={{ fontSize: "50px" }} />
                        </span>
                    </div> */}
                    <div style={{height:'20px'}}>

                    {item.status === '0' &&
                        (
                            <span className={`badge badge-${color}`} style={{ margin: "5px" }}>Upcoming</span>
                        )
                    }
                    {item.status === '1' &&
                        (
                            <span className={`badge badge-${color}`} style={{ margin: "5px" }}>LIVE</span>
                        )}
 
                    <div className="pull-right" style={{ bottom: "0px" }}>
                        {isPremium &&
                            (
                                <span className="badge badge-info" style={{ margin: "5px" }}>
                                    <LocalMoneyValue showSymbol value={item.ppv_value} />
                                </span>
                            )}
                        {/* {!isPremium &&
                            (
                                <span className="badge badge-success" style={{ margin: "5px" }}>
                                    free
                                </span>
                            )} */}
                    </div>
                    </div>

                    <div className="event-content">
                        <ul className="event-details" >
                            <li>  <h4 className='text-white' >{item.title} </h4></li>
                            {
                                /* 
                                <li className="">
                                    <div>
                                        <Icon type="user" /> {(item.user && item.user.name) || "N/A"}
                                    </div>
                                </li> 
                                */
                            }
                        <li className="">
                                {buildCategoryHashtags(item)}
                            </li>
                            <li className="text-white">
                                {/* {item.views || 0} views */}
                                {buildDestinations()}
                            </li>
                            {/* <li>
                        <Paragraph ellipsis={{ rows: 2, symbol: 'more' }}>
                            {item.description}
                        </Paragraph>
                    </li> */}

                        </ul>


                    </div>
                </div>
            </div>
        </Link>
    )
}

export default function LiveEvents({ onReady, user_id, title ,description}) {
    const itemsPerPage = 15;
    const [overallCount, setOveralCount] = useState(0);
    var itemsSet = 1;
    const [state, setstate] = useState([]);

    const [isLoading, setIsLoading] = useState(false);
    const webs = new StreamWebService();
    const [payload, setPayload] = useState({
        page: itemsSet, perPage: itemsPerPage,
        user: user_id
    });
    const getPublicEvents = () => {
        setIsLoading(true)

        webs.getOpenPublicStreams(payload)
            .then(res => {
                setOveralCount(res.data.overallCount)
                return res.data.entries
            })
            .then(items => {

                setstate([...state, ...items]);
                onReady && onReady(items);
            })

            .finally(_ => setIsLoading(false));
    }

    const loadMore = () => {
        setPayload({ ...payload, page: payload.page + 1 })

    }

    const cleanup = () => setstate([]);
    useEffect(() => {
        getPublicEvents();
    }, [payload])
    useEffect(() => {
        getPublicEvents()
        return cleanup
    }, [])


    return (
        <div className=" p-2 md:p-5 section">
            <Greetings className="header text-center w-100" 
            title= {title || <h4>Watch Events</h4>}
            description= {description ||  "See what others are streaming"}
            
            />
            <div className="live-events m-t-30">
                <div className="live-event-search-container mx-auto md:w-1/3  " >
                    <CustomSearch
                        onListUpdate={items => setstate(items)}
                        onLoading={_loading => setIsLoading(_loading)}
                        webservice={_ => webs.getOpenPublicStreams(_)}
                    />
                </div>

                <div className="events" style={{ width: "100%", marginTop: "40px" }}>
                    {isLoading
                        ?
                        <LoadingCards />
                        :
                        state.length > 0
                            ?
                            state.map(item => <LiveEventItem item={item} key={item.id} />)
                            :
                            <Empty />
                    }


                </div>


            </div>
            <div className="text-center m-t-40" hidden={itemsPerPage >= overallCount}  >
                <button className="btn btn-info" onClick={loadMore}>  Load More  </button>
            </div>
        </div>

    )
}
